import { userConstants } from './constantData';

export const LIVE_CATALOG_SPORTS_KIDS_PAGE_DATA = {
  live_page: {
    page_view: {
      hash: 'p-037.001.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
  },
  catalog_page: {
    page_view: {
      hash: 'p-031.001.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
  },
  sports_page: {
    page_view: {
      hash: 'p-038.001.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
  },
  kids_page: {
    page_view: {
      hash: 'p-032.001.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
  },
};
